export const CHOOSE_EVENT_OPTION = 'EVENTS_CHOOSE_EVENT_OPTION'
export const LOAD_EVENT = 'EVENTS_LOAD_EVENT'
export const SET_EXECUTED_EVENT = 'EVENTS_SET_EXECUTED_EVENT'

export const chooseEventOption = (data) => {
  return { type: CHOOSE_EVENT_OPTION, data }
}
export const loadEvent = () => {
  return { type: LOAD_EVENT }
}
export const setExecutedEvent = (event) => {
  return { type: SET_EXECUTED_EVENT, data: event }
}
